import { observer } from "mobx-react";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Button, Form, Grid, Header, Icon, Table, Select, Segment, Input } from "semantic-ui-react";
import { AlertMessage, DateInput, Text } from "../../../components/common";
import { CurrencyInput } from "../../../components/common/input";
import { NoPermissionMessage } from "../../../components/permission";
import { currency } from "../../../utils/format-helper";
import { hasPermission } from "../../../utils/render-by-permission";
import { IDebtCollectionSueModel } from "../DebtCollectionModel";

interface IDebtCollectionSueConfiscated extends WithTranslation {
  debtSue: IDebtCollectionSueModel;
  editMode?: boolean;
}

@observer
class DebtCollectionSueConfiscated extends React.Component<
  IDebtCollectionSueConfiscated
> {
  state = {
    listData: [],
    formData: {
      result: "",
      amount: "",
      interest: "",
      remain: ""
    }
  }
  public render() {
    const { t, debtSue } = this.props;
    return (
      <Form>
        <Header
          size="medium"
          content={
            t(
              "ข้อมูลการยึดทรัพย์"
            )
          }
          subheader={
            t(
              ""
            )
          } />
        {this.renderForm()}
        <br />
        <br />
        {this.renderTable()}
      </Form>
    );
  }
  public renderForm() {
    const { t, editMode } = this.props
    if (!editMode) return ("");
    return (
      <Segment padded>
        <Form size="mini">
          <Grid columns={2}>
            <Grid.Row verticalAlign="top">
              <Grid.Column width={10}>
                <Header
                  size="medium"
                  content={t(
                    "เพิ่มข้อมูลการอายัด"
                  )}
                  subheader={t(
                    ""
                  )}
                  style={styles.header}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <br />

          <Form.Group widths="equal">
            <Form.Field
              id="form-letter-date-form"
              control={Input}
              label={t("ผลการบังคับคดี (จำนวนเงิน)")}
              value={currency(this.state.formData.result)}
              onChange={
                (e: any, data: any) => this.setState({ formData: { ...this.state.formData, result: data.value.replace(/,/g, "") } })
              }
            />
            <Form.Field
              id="form-letter-date-form"
              control={Input}
              label={t("เงินต้น")}
              value={currency(this.state.formData.amount)}
              onChange={
                (e: any, data: any) => this.setState({ formData: { ...this.state.formData, amount: data.value.replace(/,/g, "") } })
              }
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field
              id="form-letter-date-form"
              control={Input}
              label={t("ดอกเบี้ย")}
              value={currency(this.state.formData.interest)}
              onChange={
                (e: any, data: any) => this.setState({ formData: { ...this.state.formData, interest: data.value.replace(/,/g, "") } })
              }
            />
            <Form.Field
              id="form-letter-date-form"
              control={Input}
              label={t("คงเหลือเงินที่ยังต้องได้รับ (บาท)")}
              value={currency(this.state.formData.remain)}
              onChange={
                (e: any, data: any) => this.setState({ formData: { ...this.state.formData, remain: data.value.replace(/,/g, "") } })
              }
            />
          </Form.Group>
        </Form>
        <Grid columns="equal" style={styles.gridButtom}>
          <Grid.Row verticalAlign="middle">
            <Grid.Column textAlign="right">
              <Button
                icon
                labelPosition="left"
                color="blue"
                style={styles.button}
                onClick={this.onClickSave}
              >
                {t("เพิ่มข้อมูล")}
                <Icon name="add" />
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    )
  }

  public renderTable() {
    return (
      <React.Fragment>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>ตั้งเรื่องบังคับคดี(ครั้ง)</Table.HeaderCell>
              <Table.HeaderCell>ผลการบังคับคดี (จำนวนเงิน)</Table.HeaderCell>
              <Table.HeaderCell>เงินต้น</Table.HeaderCell>
              <Table.HeaderCell>ดอกเบี้ย</Table.HeaderCell>
              <Table.HeaderCell>คงเหลือเงินที่ยังต้องได้รับ (บาท)</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {
              this.state.listData.map((dat: any, i) => {
                return (
                  <Table.Row>
                    <Table.Cell>{i + 1}</Table.Cell>
                    <Table.Cell>{dat.result}</Table.Cell>
                    <Table.Cell>{dat.amount}</Table.Cell>
                    <Table.Cell>{dat.interest}</Table.Cell>
                    <Table.Cell>{dat.remain}</Table.Cell>
                  </Table.Row>
                )
              })}
          </Table.Body>
        </Table>
      </React.Fragment>
    )
  }

  public onClickSave = () => {
    let data = {
      result: this.state.formData.result,
      amount: this.state.formData.amount,
      interest: this.state.formData.interest,
      remain: this.state.formData.remain,
    }
    this.setState(
      { listData: [...this.state.listData, data] }
    )
    // reset Form
    this.setState(
      {
        formData: {
          result: "",
          amount: "",
          interest: "",
          remain: ""
        }
      }
    )



  }

  public getOptions = (val: number) => {
    let ret = [];
    for (let i = 1; i <= val; i++) {
      let d = { key: i, value: i, text: i };
      ret.push(d);
    }
    return ret;
  }

  public renderResult = (e: any, data: any) => {
    const { t, debtSue } = this.props;
    //let totalAmount = debtSue.judgementBalance +     
    const submitDate = new Date(debtSue.submitDate);
    const lastDate = new Date(debtSue.submitDate);
    let curDate = new Date(debtSue.submitDate);
    //console.log(debtSue);

    if (submitDate.getDay() > 5) {
      lastDate.setMonth(lastDate.getMonth() + data.value + 1);
      curDate = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 5);
    } else {
      lastDate.setMonth(lastDate.getMonth() + data.value);
      curDate = new Date(curDate.getFullYear(), curDate.getMonth(), 5);
    }

    let finalDate = new Date(lastDate.getFullYear() + "-" + lastDate.getMonth().toString().padStart(2, '0') + '-05');
    let dateDiff = (finalDate.getTime() - submitDate.getTime()) / (1000 * 3600 * 24);
    let totalInterest = 0
    if (debtSue.judgementInterestRate > 0) {
      totalInterest = debtSue.judgementBalance * (debtSue.judgementInterestRate / 100) * (dateDiff / 365.25);
    }

    let records = [];
    let i: number;
    let noCount = data.value;
    //let totalAll = debtSue.judgementBalance + debtSue.fee + debtSue.lawyerFee + totalInterest + debtSue.otherExpense + 0;
    let sumAll: number = 0;

    sumAll = Number(debtSue.judgementBalance) + Number(debtSue.fee) + Number(debtSue.lawyerFee) + Number(debtSue.otherExpense) + totalInterest;
    for (i = 1; i <= data.value; i++) {
      let data = {
        record_no: i,
        paidDate: curDate.toLocaleDateString("th-TH", { year: 'numeric', month: 'long', day: 'numeric' }),
        judgementBalance: debtSue.judgementBalance / noCount,
        lawyerFee: debtSue.lawyerFee / noCount,
        fee: debtSue.fee / noCount,
        otherExpense: debtSue.otherExpense / noCount,
        Interest: totalInterest / noCount,
        sumAll: sumAll / noCount
      }
      curDate = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 5);
      records.push(data);
    }
    let total = {
      judgementBalance: debtSue.judgementBalance,
      lawyerFee: debtSue.lawyerFee,
      fee: debtSue.fee,
      otherExpense: debtSue.otherExpense,
      Interest: totalInterest,
      sumAll: sumAll
    }

    //this.setState({ listData: records })
    this.setState({ listData: records });
    this.setState({ total: total });
  }

  public toNextMonth(d: Date) {
    if (d.getDay() > 5) {

    } else {
      d.setMonth(d.getMonth() + 2);
    }
    let mon = new Date(d.getFullYear() + "-" + d.getMonth().toString().padStart(2, '0') + '-05');
    return mon;
  }
}

const styles: any = {
  list: {
    display: "flex",
    flexWrap: "wrap"
  },
  listItem: {
    marginLeft: 0,
    marginRight: 7
  },
  listLastItem: {
    marginLeft: 0
  },
  table: {
    fontSize: ".7em"
  },
  containerTable: {
    overflowX: "auto",
    overflowY: "hidden"
  },
  icon: {
    marginRight: 0,
    marginLeft: 4
  },
  list1: {
    marginBottom: 0
  },
  list2: {
    marginTop: 0,
    marginBottom: 24
  },
  button: {
    marginRight: 0,
    marginLeft: 14,
    paddingTop: 10
  },
};

export default withTranslation()(DebtCollectionSueConfiscated);